export default {
  game: {
    title: "MapleStory R-Evolution Single-handed Challenge",
    description:
      "NEXON-licensed mobile RPG MapleStory R-Evolution is open for pre-registration! Sign up to claim limited-edition outfits, SSR pets, and other exclusive rewards!",
    keywords:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    description2:
      "Welcome to NEXON-licensed mobile RPG MapleStory R-Evolution! Download now to claim limited-edition outfits, SSR pets, and other exclusive rewards!",
    keywords2:
      "MapleStory, MapleStory R, MapleStory M, MapleStory: Idle RPG, NEXON, characters, adventure, idle, skills, Zakum, orange mushroom, mushroom, pink bean, yeti, green snail, slime, ludibrium, henessys, card game, team battle, team fight, boss fight, RPG, Idle RPG, Dragon, game, mobile game, Sword, Upgrade, Class, Warrior, Mage, Archer, Swordsman, Bowman, Thief, Cannoneer, magician, brave, magic, battle, 2D game, PVP, PVE, SAO, MMORPG, Action RPG, ARPG, JRPG, SSR pets, Download, Pre-register, reward Legend of Mushroom, Legend of Zelda, Legend of Slime, Nobody's Adventure, Guardian Tales, LaTale, LaTale M, Sky Utopia, MeowHeroes, MapleHeroes, RO, Ragnarok",
    language_1: "Monster\nDefeat\nReward",
    language_2: "Zakum\nDefeat\nReward",
    language_3: "Achieved",
    language_4: "Unachieved",
    language_5: "Claim",
    language_6: "Copy",
    language_7: "The event has ended; only redeem code can be claimed.",
    language_8: "Copy Redeem Code to get rewards in-game!",
    language_9: "Complete quests to receive  a redeem code！",
    language_10: "Download to get",
    language_11: "Store register to get",
    language_12: "Zakum Outfit",
    language_13: "Download",
    language_14: "REGISTER",
    // language_15: "Available on the",
    // language_16: "Pre-order on the",
    // language_17: "GET IT ON",
    // language_18: "PRE-REGISTER ON",
    // language_19: "follow us",
    language_20: "REGISTER",
    language_21: "Tap to claim code",
    language_22: "Copy successful",
    language_23: "Copy fails, please try to copy manually",
    language_24: "Rule",
    confirmDialog: {
      language_1: "Already defeated ",
      language_2: " monsters,",
      language_3: "can get ",
      language_4: "（up to 20）",
      language_5: "Can only claim the reward once, confirm to claim?",
      language_6: "Claim",
      language_7: "Cancel",
    },
    endDialog: {
      language_1: "The event has ended",
    },
    registerDialog: {
      language_1: "Please complete Email Pre-registration",
      language_2: "to join the event and get",
      language_3: "SSR Pet",
      language_4: "Enter your email",
      language_5: "l agree to the ",
      language_6: "Terms of Service",
      language_7: " and ",
      language_8: "Privacy Policy",
      //   language_9: "REGISTER",
      language_10: "SSR",
      language_11: "-Jr. Cellion",
      language_12:
        "Please agree to the Terms of Service and Privacy Policy first.",
    },
    taskDialog: {
      language_1: "",
      language_2: " Monsters Defeat Completed",
      language_3: "BOSS",
      language_4: "-Zakum Defeat Completed",
    },
  },
  treasure: {
    passInput: "Please enter the password",
    emailInput: "Enter your email",
    copySuccess: "Copy successfully",
    copyFail: "Copy failed, please copy manually",
    emptyPass: "Password cannot be empty",
  },
  reserve: {
    pleaseEnter: "Please enter a valid email address.",
    pleaseAgree: "Please agree to the terms",
    emailPlaceholder: "Please enter a valid email address.",
    successShip: "Ticket Num.",
    // 邀请文本
    invitedText: "Total Invitees:",
    inviteLinkText: "Invitation Link:",
    copyLinkText: "Copy Link",
    copyLinkSuccess: "The link was copied successfully.",
    shareToText: "Share to:",
    // 导航文本
    nav1: "Pre-registrations",
    nav2: "Single-handed Challenge",
    nav3: "Class",
    nav4: "Introduction",
    nav5: "Official Website",
    // 预约错误提示
    emailEmpty: "Please enter a valid email address.",
    emailInvalid: "Invalid email format. Please check and re-enter.",
    agreeTerms: "Please agree to the terms",
    agreementText: "Agree",
    termsText: "Terms of Service",
    andText: "and",
    privacyText: "Privacy Policy",
    // 预约人数文本
    totalNumberText:
      "Adventurers Already Claimed Their Pre-registration Rewards!",
    successfulResText: "Pre-registration complete.",
    successfulResText2: "Welcome back!",
  },
  foot: {
    agree: "I agree to",
    and: "and",
    termsOfService: "Terms of Membership",
    privacyPolicy: "Privacy Policy",
    Notice: "Notices",
    EmailText: "GM Email：",
    info: "c",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
    tkingdomssea:
      "Copyright© 2025 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
    rotwilightglobal:
      "© Gravity Co., Ltd. & Lee MyoungJin(studio DTDS). All Rights Reserved.",
  },
  news: {
    NextPage: "Next Page",
    PrevPage: "Previous Page",
    NextContent: "Next Post",
    PrevContent: "Previous Post",
    Return: "Back",
    ReturnList: "Back to List",
    More: "More",
    None: "gone",
  },
};
